import {CommonMessages} from '../common.messages';

export const PanelClientsEditBankAccountsMessages = {
    GetLinkedAccountsFailed: {
        key: 'GetLinkedAccountsFailed',
        message: 'Error while communication with the server. Unable to get client bank accounts.'
    },
    ...CommonMessages
};
